
import { Cart } from "../../constants/types";

export default () => {

    const localCart: Cart = JSON.parse(localStorage.getItem('ayisenCart') || '[]');
    return localCart;

}
